import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, Fragment as _Fragment, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "flex flex-col" };
const _hoisted_2 = { class: "flex flex-col justify-start items-start max-w-full border-b pb-4" };
const _hoisted_3 = { class: "w-full" };
const _hoisted_4 = ["title"];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("em", { class: "fa fa-chevron-left mr-1 text-sm cursor-pointer" }, null, -1);
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = { class: "flex-grow whitespace-nowrap overflow-hidden truncate font-noto" };
const _hoisted_8 = {
    key: 0,
    class: "flex w-full justify-start mt-2"
};
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("em", { class: "far fa-eye fa-lg" }, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-pen fa-lg" }, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-download fa-lg" }, null, -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-trash fa-lg" }, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-save fa-lg" }, null, -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-network-wired fa-lg" }, null, -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-lg fa-share-alt" }, null, -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-lg fa-trash-restore" }, null, -1);
const _hoisted_17 = {
    key: 0,
    class: "flex justify-between items-center max-w-full mt-3"
};
const _hoisted_18 = { class: "w-full text-md text-primary font-bold" };
const _hoisted_19 = {
    key: 1,
    class: "fas fa-folder"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "flex flex-col" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "max-w-full mt-4" }, [
        /*#__PURE__*/ _createElementVNode("h2", { class: "font-bold pb-1 text-base truncate font-noto" }, "Details")
    ])
], -1);
const _hoisted_21 = { class: "py-4" };
const _hoisted_22 = { class: "grid grid-cols-12 grid-row items-center text-sm" };
const _hoisted_23 = { class: "text-gray-600 col-span-6" };
const _hoisted_24 = { class: "col-span-6" };
const _hoisted_25 = { class: "grid grid-cols-12 grid-row items-center text-sm" };
const _hoisted_26 = { class: "text-gray-600 col-span-6" };
const _hoisted_27 = { class: "col-span-6" };
const _hoisted_28 = { class: "grid grid-cols-12 grid-row items-center text-sm" };
const _hoisted_29 = { class: "text-gray-600 col-span-6" };
const _hoisted_30 = { class: "col-span-6" };
const _hoisted_31 = { class: "grid grid-cols-12 grid-row items-center text-sm" };
const _hoisted_32 = { class: "text-gray-600 col-span-6" };
const _hoisted_33 = { class: "col-span-6" };
const _hoisted_34 = { class: "flex flex-col text-sm mt-2" };
const _hoisted_35 = { class: "text-gray-600 col-span-2 capitalize pt-1 mb-2" };
const _hoisted_36 = { class: "col-span-10" };
const _hoisted_37 = ["disabled"];
const _hoisted_38 = {
    key: 0,
    class: "mb-4"
};
const _hoisted_39 = { class: "font-bold pb-2 text-lg font-noto" };
const _hoisted_40 = {
    key: 0,
    class: "text-center text-gray-600 p-5 text-sm"
};
const _hoisted_41 = {
    key: 1,
    class: "mt-2 overflow-hidden h-full"
};
const _hoisted_42 = { class: "mb-4" };
const _hoisted_43 = { class: "font-bold pb-2 text-lg font-noto" };
export function render(_ctx, _cache) {
    const _component_Button = _resolveComponent("Button");
    const _component_CustomSelect = _resolveComponent("CustomSelect");
    const _component_data_table = _resolveComponent("data-table");
    const _component_permissionComponent = _resolveComponent("permissionComponent");
    const _component_details_sidebar = _resolveComponent("details-sidebar");
    const _component_confirm_modal = _resolveComponent("confirm-modal");
    const _directive_copy_to_clipboard = _resolveDirective("copy-to-clipboard");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_details_sidebar, null, _createSlots({
            header: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", {
                                title: _ctx.selectedFile.filename,
                                class: "flex flex-row text-md text-primary font-bold items-center min-w-0"
                            }, [
                                _createElementVNode("div", {
                                    onClick: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_ctx.collapseSidebar && _ctx.collapseSidebar(...args))),
                                    class: "-ml-3.5 mr-2"
                                }, _hoisted_6),
                                (_openBlock(), _createElementBlock("div", {
                                    class: "mr-1",
                                    key: _ctx.selectedFile.extension
                                }, [
                                    _createElementVNode("em", {
                                        class: _normalizeClass(_ctx.getFileIcon)
                                    }, null, 2)
                                ])),
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createTextVNode(_toDisplayString(_ctx.selectedFile.filename) + "." + _toDisplayString(_ctx.selectedFile.extension), 1)
                                ])), [
                                    [_directive_copy_to_clipboard]
                                ])
                            ], 8, _hoisted_4)
                        ]),
                        (_ctx.filePermissions)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_Button, {
                                    class: "hover:text-blue-800 text-blue-500",
                                    shadowless: "",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.$emit('preview-item')), ["exact"])),
                                    title: `${_ctx.$t('misc.actions.preview')}`
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_9
                                    ]),
                                    _: 1
                                }, 8, ["title"]),
                                (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.files, operation: _ctx.AccessOperations.rename }) && _ctx.filePermissions.canWrite)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                        key: 0,
                                        class: "hover:text-blue-800 text-blue-500",
                                        shadowless: "",
                                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.$emit('write-item')), ["exact"])),
                                        title: `${_ctx.$t('misc.actions.rename')}`
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_10
                                        ]),
                                        _: 1
                                    }, 8, ["title"])), [
                                        [_vShow, !_ctx.fileDetails.isArchived]
                                    ])
                                    : _createCommentVNode("", true),
                                _createVNode(_component_Button, {
                                    class: "hover:text-blue-800 text-blue-500",
                                    shadowless: "",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.$emit('download-item')), ["exact"])),
                                    title: `${_ctx.$t('misc.actions.download')}`
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_11
                                    ]),
                                    _: 1
                                }, 8, ["title"]),
                                (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.files, operation: _ctx.AccessOperations.delete }) && _ctx.filePermissions.canWrite)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                        key: 1,
                                        class: "hover:text-blue-800 text-blue-500",
                                        shadowless: "",
                                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.$emit('delete-item')), ["exact"])),
                                        title: `${_ctx.$t('misc.actions.delete')}`
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_12
                                        ]),
                                        _: 1
                                    }, 8, ["title"])), [
                                        [_vShow, !_ctx.fileDetails.isArchived]
                                    ])
                                    : _createCommentVNode("", true),
                                (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.files, operation: _ctx.AccessOperations.edit }) && _ctx.filePermissions.canWrite)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                        key: 2,
                                        class: _normalizeClass({ 'hover:text-blue-800 text-blue-500': _ctx.unsavedChanges, 'text-gray-300': !_ctx.unsavedChanges }),
                                        shadowless: "",
                                        disabled: !_ctx.unsavedChanges,
                                        onClick: _withModifiers(_ctx.saveDetails, ["exact"]),
                                        title: `${_ctx.$t('misc.actions.save')}`
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_13
                                        ]),
                                        _: 1
                                    }, 8, ["class", "disabled", "onClick", "title"])), [
                                        [_vShow, !_ctx.fileDetails.isArchived]
                                    ])
                                    : _createCommentVNode("", true),
                                (_ctx.isVaultAdmin && _ctx.config.enableWebdav)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                        key: 3,
                                        class: "hover:text-blue-800 text-blue-500",
                                        shadowless: "",
                                        onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.$emit('mount-item')), ["exact"])),
                                        title: `${_ctx.$t('webdav.mount')}`
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_14
                                        ]),
                                        _: 1
                                    }, 8, ["title"])), [
                                        [_vShow, !_ctx.fileDetails.isArchived]
                                    ])
                                    : _createCommentVNode("", true),
                                (_ctx.filePermissions.canWrite)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                        key: 4,
                                        class: "hover:text-blue-800 text-blue-500",
                                        shadowless: "",
                                        onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (_ctx.$emit('share-item')), ["exact"])),
                                        title: `${_ctx.$t('misc.actions.share')}`
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_15
                                        ]),
                                        _: 1
                                    }, 8, ["title"])), [
                                        [_vShow, !_ctx.fileDetails.isArchived]
                                    ])
                                    : _createCommentVNode("", true),
                                (_ctx.isVaultAdmin)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                        key: 5,
                                        class: "hover:text-blue-800 text-blue-500",
                                        shadowless: "",
                                        onClick: _cache[7] || (_cache[7] = _withModifiers(($event) => (_ctx.recoverFiles()), ["exact"])),
                                        title: `${_ctx.$t('misc.actions.recover')}`
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_16
                                        ]),
                                        _: 1
                                    }, 8, ["title"])), [
                                        [_vShow, _ctx.fileDetails.isArchived]
                                    ])
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]),
            _: 2
        }, [
            (_ctx.selectedFile)
                ? {
                    name: "content",
                    fn: _withCtx(() => [
                        (_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.folders, operation: _ctx.AccessOperations.move }) && _ctx.workspaceFolders.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("span", _hoisted_18, [
                                    (_openBlock(), _createBlock(_component_CustomSelect, {
                                        disabled: _ctx.selectedFile.isArchived,
                                        modelValue: _ctx.selectedFolder,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.selectedFolder) = $event)),
                                        key: _ctx.selectedFile.parentUuid,
                                        "default-icon": "fas fa-folder",
                                        inputs: _ctx.workspaceFolders,
                                        "object-value": "name",
                                        translation: "folder"
                                    }, {
                                        icon: _withCtx(({ selected }) => {
                                            var _a, _b;
                                            return [
                                                (_openBlock(), _createElementBlock("div", {
                                                    key: selected.folderUuid
                                                }, [
                                                    (selected.metaData)
                                                        ? (_openBlock(), _createElementBlock("em", {
                                                            key: 0,
                                                            class: _normalizeClass(["fas", `fa-${(_a = selected.metaData) === null || _a === void 0 ? void 0 : _a.icon}`]),
                                                            style: _normalizeStyle(`color: ${(_b = selected.metaData) === null || _b === void 0 ? void 0 : _b.color}`)
                                                        }, null, 6))
                                                        : (_openBlock(), _createElementBlock("em", _hoisted_19))
                                                ]))
                                            ];
                                        }),
                                        _: 1
                                    }, 8, ["disabled", "modelValue", "inputs"]))
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('file.lastAccessed')), 1),
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createTextVNode(_toDisplayString(_ctx.selectedFile.lastAccessed ? _ctx.formatDate(_ctx.selectedFile.lastAccessed) : _ctx.$t('misc.neverAccessed')), 1)
                                ])), [
                                    [_directive_copy_to_clipboard]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('file.lastModified')), 1),
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createTextVNode(_toDisplayString(_ctx.selectedFile.lastModified ? _ctx.formatDate(_ctx.selectedFile.lastModified) : _ctx.$t('misc.neverModified')), 1)
                                ])), [
                                    [_directive_copy_to_clipboard]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('file.size')), 1),
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createTextVNode(_toDisplayString(_ctx.selectedFile.size ? _ctx.formatBytes(_ctx.selectedFile.size, 2) : '0 Bytes'), 1)
                                ])), [
                                    [_directive_copy_to_clipboard]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('file.created')), 1),
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.selectedFile.createdOn)), 1)
                                ])), [
                                    [_directive_copy_to_clipboard]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('misc.notes')), 1),
                                _createElementVNode("div", _hoisted_36, [
                                    (_ctx.selectedFile && _ctx.filePermissions)
                                        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                            key: 0,
                                            disabled: !_ctx.hasAccessToOperation({ accessType: _ctx.AccessType.files, operation: _ctx.AccessOperations.edit }) || !_ctx.filePermissions.canWrite || _ctx.selectedFile.isArchived,
                                            rows: "4",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.selectedFile.note) = $event)),
                                            class: "w-full p-1",
                                            style: { "resize": "none" },
                                            maxlength: "200"
                                        }, "\n                " + _toDisplayString(_ctx.selectedFile.note) + "\n              ", 9, _hoisted_37)), [
                                            [_vModelText, _ctx.selectedFile.note]
                                        ])
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", null, [
                            (_ctx.isVaultAdmin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createElementVNode("h2", _hoisted_39, _toDisplayString(_ctx.$t('file.accessHistory')), 1),
                                    (!_ctx.accessHistory || _ctx.accessHistory.length === 0)
                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_40, _toDisplayString(_ctx.$t('file.noAccessHistory')), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                            _createVNode(_component_data_table, {
                                                name: "accessHistoryTable",
                                                headers: ['accessedOn', 'type', 'user'],
                                                "selected-fields": ['accessedOn', 'type', 'username'],
                                                data: _ctx.accessHistory,
                                                "has-more": _ctx.accessHistory.length >= 5,
                                                "disabled-more": _ctx.hasMoreDisabled,
                                                onShowMore: _ctx.addMore,
                                                class: "max-h-72"
                                            }, null, 8, ["data", "has-more", "disabled-more", "onShowMore"])
                                        ]))
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.isVaultAdmin && _ctx.selectedFile)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_42, [
                                        _createElementVNode("h2", _hoisted_43, _toDisplayString(_ctx.$t('file.allowedUsers')), 1)
                                    ]),
                                    _createVNode(_component_permissionComponent, {
                                        disabled: _ctx.selectedFile.isArchived,
                                        permissions: _ctx.selectedFile.permissions,
                                        "onUpdate:permissions": _cache[10] || (_cache[10] = ($event) => ((_ctx.selectedFile.permissions) = $event))
                                    }, null, 8, ["disabled", "permissions"])
                                ], 64))
                                : _createCommentVNode("", true)
                        ])
                    ])
                }
                : undefined
        ]), 1024),
        (_ctx.unsavedChanges && _ctx.hasAccessToOperation({ accessType: _ctx.AccessType.files, operation: _ctx.AccessOperations.edit }))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed top-0 left-0 opacity-40 h-full w-full p-4",
                style: { "z-index": "-1" },
                onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.unsavedChangesModal = true))
            }))
            : _createCommentVNode("", true),
        (_ctx.unsavedChangesModal && _ctx.hasAccessToOperation({ accessType: _ctx.AccessType.files, operation: _ctx.AccessOperations.edit }))
            ? (_openBlock(), _createBlock(_component_confirm_modal, {
                key: 1,
                show: _ctx.unsavedChangesModal,
                "onUpdate:show": _cache[12] || (_cache[12] = ($event) => ((_ctx.unsavedChangesModal) = $event)),
                onConfirm: _ctx.abandonChanges
            }, {
                header: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('file.unsavedChanges')), 1)
                ]),
                message: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('file.unsavedChangesMessage')), 1)
                ]),
                _: 1
            }, 8, ["show", "onConfirm"]))
            : _createCommentVNode("", true)
    ], 64));
}
